<template>
  <modal-layout :is-open="isOpen" class="Modal__accordion" @close="modalClose">
    <div class="Modal_area">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="クラス詳細モーダルを閉じる"
        @click="modalClose"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_title">
        <span class="Modal_title_date">クラスで選ぶ</span>
      </div>
      <div class="Modal_inner modal__container">
        <ul class="Search_class_list">
          <li
            v-for="category in listCategories"
            :key="category.id"
            class="Search_class_list_box"
            style="text-transform:capitalize;"
          >
            <div
              class="Search_class_list_category"
              :style="`
                background-image: url(${encodeURI(decodeURI(category.icon_url))});
                background-color: ${category.background_color};
                --border-color: ${category.color};
              `"
              :class="showCategories[category.id] ? '_active' : ''"
              @click="toggleShow(category.id)"
            >
              {{ category.name }}
            </div>
            <transition name="collapse">
              <div v-show="showCategories[category.id]" class="collapse-content">
                <li
                  v-for="progCat in filteredPrograms(category.id)"
                  v-show="progCat.display_status === 1"
                  :key="progCat.id"
                >
                  <a
                    class="Search_class_list_link"
                    :style="`
                      background-color: ${category.background_color};
                    `"
                    @click="searchCategory(progCat.id, progCat.name)"
                  >
                    <span class="Search_class_list_tx">{{ progCat.name }}</span>
                  </a>
                </li>
              </div>
            </transition>
          </li>
        </ul>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout'
import programcategoryService from '@/services/programcategoryService'
export default {
  name: 'MelonTVScheduleModal1',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listPrograms: {},
      listCategories: [],
      showCategories: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    modalClose() {
      this.$emit('close')
    },
    async init() {
      await this.getListPrograms()
    },
    async getListPrograms() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await programcategoryService.index()
      this.listPrograms = response.data
      this.listCategories = Array.from(
        new Map(this.listPrograms.map(item => [item.master_mindful_category?.id, item.master_mindful_category])).values()
      ).sort((a, b) => a.id - b.id)
      this.$store.dispatch('loading/updateLoading', false)
    },
    searchCategory(categoryId, categoryName) {
      this.$emit('searchMelonTv', { searchCategory: categoryId, name: categoryName })
      this.$emit('close')
    },
    filteredPrograms(categoryId) {
      return this.listPrograms.filter(item => item.master_mindful_category?.id === categoryId)
    },
    toggleShow(categoryId) {
      this.$set(this.showCategories, categoryId, !this.showCategories[categoryId])
    }
  }
}
</script>
